import { AxiosResponse } from "axios";
import { ClaimErrors } from "./Types";

export const mapClaimErrorRequests =
(resp: AxiosResponse): ClaimErrors => resp.data as ClaimErrors;
